import React from 'react'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as USER_ACTION from '@store/user/actions'
import * as SHARED_ACTION from '@store/shared/actions'

import { isEqual, isEmpty } from 'lodash'

import { Modal, Icon } from '@components/shared/elements'
import MaskedInput from 'react-text-mask'
import API_SHARED from '@api/shared'

import TOOLS from '@helpers/tools'
import COOKIES from '@helpers/cookies'
import slugify from 'slugify'

import { handleBlurDatalayer, genericModalDataLayer } from '@helpers/BI'

class ModalChat extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showMenuChat: false,
      name: '',
      email: '',
      phone: '',
      shBranchId: '',
      shBranchName: '',
      shBranchModalId: '',
      stateInitials: '',
      nameDirt: false,
      emailDirt: false,
      phoneDirt: false,
      blockSending: false,
      success: false,
      error: false,
      warn: false,
      iframeOpened: false,
      fullscreen: false,
      iframe: {
        url: '',
        width: '',
        height: '',
      },
      hasBranches: false,
      branchSelected: '',
      hasFacilitaMsg: '',
      privacyPolicies: true,
      hasListaFiliais: false,
      singleFilial: false,
      listaFiliaisAtendimento: [],
      successMessage: '',
      errorMessage: '',
      warnMessage: '',
    }
    this.el = React.createRef()
  }

  componentDidMount() {
    let reduxUser = this.props.currentUser
    if (!isEmpty(reduxUser)) {
      this.setState({ name: reduxUser.Nome, nameDirt: true })
      this.setState({ emailDirt: true, email: reduxUser.Email })
      this.setState({ phoneDirt: true, phone: reduxUser.Telefone })
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.shBranchId === '') {
      if (prevProps.branches.sucess) {
        let sufix = this.props.product.success ? '-ficha-imovel' : ''
        this.setState({
          shBranchId: this.props.branches.codigoFilialPadrao,
          shBranchName: 'Filial Padrão',
          shBranchModalId: this.props.branches.CodigoPadraoIntegracaoChat + sufix,
        })
      }
    }

    if (prevProps.region !== this.props.region) {
      let stateList = this.props.regions
      let praca
      if (stateList.success) {
        let busca = await stateList.estados.find(item => item.IdEstado === this.props.region)
        praca = busca.Uf.toLowerCase()
        this.setState({
          stateInitials: `${praca}`,
        })
      }
    }

    if (prevState.blockSending !== this.state.blockSending) {
      setTimeout(() => {
        this.setState({
          name: '',
          phone: '',
          email: '',
          shBranchId: '',
          stateInitials: '',
          nameDirt: false,
          phoneDirt: false,
          blockSending: false,
          success: false,
          error: false,
          hasBranches: false,
          branchSelected: '',
          hasFacilitaMsg: '',
          privacyPolicies: true,
        })
      }, 3000)
    }

    const listaFiliaisAtendimento = this.props.branches.listaFiliaisAtendimento
    if (!isEqual(prevState.listaFiliaisAtendimento, listaFiliaisAtendimento)) {
      this.setState({
        listaFiliaisAtendimento: listaFiliaisAtendimento,
        hasListaFiliais: !isEmpty(listaFiliaisAtendimento),
      })
      if (this.state.hasListaFiliais) {
        if (listaFiliaisAtendimento.length === 1) {
          this.setState({ singleFilial: true })
          const item = listaFiliaisAtendimento[0]
          if (this.state.shBranchId !== item.CodigoFilial) {
            this._handleChangeBranch(item)
          }
        } else {
          this.setState({ singleFilial: false })
        }
      }
    }

    if (prevState.shBranchId !== this.state.shBranchId) {
      let dadosFilial = listaFiliaisAtendimento.find(item => item.CodigoFilial === this.state.shBranchId)
      if (!isEmpty(dadosFilial)) {
        if (this.state.shBranchModalId !== dadosFilial.CodigoIntegracaoChat) {
          if (this.props.product.success) {
            this.setState({
              shBranchModalId: dadosFilial.CodigoIntegracaoChat + '-ficha-imovel',
              shBranchName: dadosFilial.Nome,
            })
          } else {
            this.setState({
              shBranchModalId: dadosFilial.CodigoIntegracaoChat,
              shBranchName: dadosFilial.Nome,
            })

          }
        }
      }
    }
  }

  _toggleMenu(event) {
    event.preventDefault()
    this.setState({
      showMenuChat: !this.state.showMenuChat,
    })
  }

  handleBranchSelect = async selectedBranch => {
    await this.setState({ branch: selectedBranch })
  }

  _handleChangeBranch(item) {
    this.setState({ branchSelected: item.Nome, shBranchId: item.CodigoFilial })
    if (this.props.product.success) {
      this.setState({
        shBranchModalId: `${this.props.branches.CodigoPadraoIntegracaoChat}-ficha-imovel`,
      })
    } else {
      this.setState({
        shBranchModalId: item.CodigoIntegracaoChat,
      })
    }
  }

  async _abrirChat(element) {
    this.setState({ nameDirt: true, emailDirt: true, phoneDirt: true })

    let nome = this.state.name
    let emailValid = TOOLS.emailValid(this.state.email)
    let phoneValid = (TOOLS.phoneValid(this.state.phone))

    if (nome !== '' && emailValid && phoneValid) {
      this.setState({ nameDirt: false, emailDirt: false, blockSending: true })

      const product = this.props.product.imovel
      const highlight = this.props.highlightModal

      let region = this.props.region === undefined
        ? product.Localizacao.IdEstado
        : this.props.region

      const regionId = parseInt(region, 10)
      const estado = this.props.locations.find(item => item.idEstado === region)
      const gaSend = COOKIES.getUtmGaSend()

      // São Paulo - Facilita
      if (regionId === 1) {
        let urlWithoutQuerystring = window.location.href.split('?')[0]
        let dadosFilial = this.props.branches.listaFiliaisAtendimento.find(item => item.CodigoFilial === this.state.shBranchId)

        let jsonBody = {}
        jsonBody['facilita_custom_page'] = document.title
        jsonBody['facilita_custom_url'] = `${urlWithoutQuerystring}?utm_campaign=${gaSend.UtmCampaign}&utm_content=${gaSend.UtmContent}&utm_medium=${gaSend.UtmMedium}&utm_source=${gaSend.UtmSource}&utm_term=${gaSend.UtmTerm}${!!gaSend.UtmGclid ? `&utm_gclid=${gaSend.UtmGclid}` : ''}`
        jsonBody['facilita_custom_selector'] = this.state.shBranchModalId
        jsonBody['name'] = this.state.name
        jsonBody['email'] = this.state.email
        jsonBody['phone'] = this.state.phone
        jsonBody['codigo_filial'] = this.state.shBranchId
        jsonBody['nome_filial'] = this.state.shBranchName
        jsonBody['client_id_ga'] = gaSend.CodigoGa
        jsonBody['idImovel'] = undefined
        jsonBody['empreendimento'] = undefined
        jsonBody['cidade'] = estado.nome
        jsonBody['IdEstado'] = regionId
        /* campos api backend */
        jsonBody['ImovelOrigemId'] = 3
        jsonBody['url'] = window.location.href
        jsonBody['utm_campaign'] = gaSend.UtmCampaign
        jsonBody['utm_content'] = gaSend.UtmContent
        jsonBody['utm_medium'] = gaSend.UtmMedium
        jsonBody['utm_source'] = gaSend.UtmSource
        jsonBody['utm_term'] = gaSend.UtmTerm
        jsonBody['utm_gclid'] = gaSend.UtmGclid
        jsonBody['mobile'] = this.state.phone
        jsonBody['ga'] = gaSend.CodigoGa
        jsonBody['IdFilial'] = dadosFilial ? dadosFilial.Id : ''
        jsonBody['NomeFilial'] = dadosFilial ? dadosFilial.Nome : 'Filial Padrão'
        jsonBody['produto'] = 31

        if (product && product.imovelId) {
          jsonBody['idImovel'] = product.imovelId
          jsonBody['produto'] = product.IdFacilita || 31
          jsonBody['empreendimento'] = product.Nome
          jsonBody['cidade'] = product.Localizacao.Cidade
        }

        if (highlight && highlight.imovelId) {
          jsonBody['idImovel'] = highlight.imovelId
          jsonBody['produto'] = highlight.idFacilita || 31
          jsonBody['empreendimento'] = highlight.imovelNome
          jsonBody['cidade'] = highlight.imovelLocalizacao
        }

        const alturaJanela = TOOLS.isMobile() ? window.innerHeight : window.innerHeight * 0.5
        const larguraJanela = TOOLS.isMobile() ? window.innerWidth : window.innerWidth * 0.5

        const windowRef = window.open(null, 'Chat-Facilita', `toolbar=0,status=0,width=${larguraJanela},height=${alturaJanela}`)

        let logPayload = {
          IdImovelOrigem: 3,
          PontoContato: 2,
          IdentificadorLog: 'E028',
          Descricao: JSON.stringify(jsonBody),
        }

        API_SHARED.contactUsByChatFacilita(jsonBody).then((response) => {
          if (response.urlChat) {
            windowRef.location = response.urlChat
            this.setState({
              nameDirt: false,
              emailDirt: false,
              phoneDirt: false,
              success: true,
            })
          } else {
            windowRef.close()
            this.setState({
              error: true,
            })
          }
        }).finally(response => {
          logPayload['IdentificadorLog'] = 'I023'
          logPayload['LeadId'] = response.IdLead
          this.props.actions.recordLog(logPayload)
        })

      } else { //RS e RJ

        let jsonBody = {}
        jsonBody['Email'] = this.state.email
        jsonBody['Nome'] = this.state.name
        jsonBody['Telefone'] = this.state.phone
        jsonBody['Praca'] = estado.sigla
        jsonBody['ImovelOrigemId'] = 3
        jsonBody['PontoContato'] = 'Chat'
        jsonBody['url'] = window.location.href
        jsonBody['EstadoId'] = regionId

        if (product && product.imovelId) {
          jsonBody['IdImovel'] = product.imovelId
          jsonBody['NomeImovel'] = product.Nome
        }

        if (highlight && highlight.imovelId) {
          jsonBody['IdImovel'] = highlight.imovelId
          jsonBody['NomeImovel'] = highlight.imovelNome
        }

        Object.assign(jsonBody, gaSend)

        this.props.actions.contactUsChat(jsonBody).then((response) => {
          if (response.Success) {
            if (response.ChatDisponivel && response.UrlChat) {
              const alturaJanela = window.innerHeight * 0.8
              const larguraJanela = window.innerWidth * 0.8

              this.setState({
                nameDirt: false,
                emailDirt: false,
                phoneDirt: false,
                iframeOpened: true,
                success: true,
                fullscreen: true,
                iframe: {
                  url: response.UrlChat,
                  height: alturaJanela,
                  width: larguraJanela,
                },
                successMessage: '',
              })
            } else {
              this.setState({ warn: true, warnMessage: response.Msg })
            }
          } else {
            this.setState({ error: true, errorMessage: response.Msg })
          }
          this.setState({ blockSending: false })
          setTimeout(() => {
            this.setState({
              warn: false,
              warnMessage: '',
              error: false,
              errorMessage: '',
            })
          }, 5000)
        })
      }
    }

    // GA data
    const elementText = slugify(element.target.innerText, { lower: true })
    genericModalDataLayer(this.props.product.imovel, this.props.locations, this.props.region, 'modal-chat', elementText)
  }

  _modalClose = () => {
    this.setState({
      iframeOpened: false,
      iframe: {
        url: '',
        width: '',
        height: '',
      },
    })
    this.props.close()
  }

  render() {
    let blockSending = this.state.blockSending
    let nameValid
    let emailValid
    let phoneValid

    let { iframe } = this.state

    if (this.state.nameDirt) {
      nameValid = (this.state.name !== '') ? 'is-valid' : 'has-error'
    }

    if (this.state.emailDirt) {
      emailValid = (TOOLS.emailValid(this.state.email)) ? 'is-valid' : 'has-error'
    }

    if (this.state.phoneDirt) {
      phoneValid = (TOOLS.phoneValid(this.state.phone)) ? 'is-valid' : 'has-error'
    }

    const listaFiliaisAtendimento = this.state.listaFiliaisAtendimento
    const mostrarListaFiliais = this.state.hasListaFiliais && !this.state.singleFilial

    return <Modal show={this.props.show} close={this._modalClose} fullscreen={this.state.fullscreen} goback={this.props.goback}>
      {!this.state.iframeOpened &&
        <form onSubmit={(event) => this._handleSubmit(event)} data-ga-name='modal-contato'>
          <h4 className='h5 mt3 mb2'><strong>Atendimento via Chat</strong></h4>
          <div className={`field-group mb2 ${nameValid === 'is-valid' && 'is-valid'} ${nameValid === 'has-error' && 'has-error'}`}>
            <label>
              <input className='mb0' type='text' value={this.state.name} onChange={(event) => this.setState({ name: event.target.value })} onBlur={(e) => { handleBlurDatalayer(e, 'name', 'Atendimento-via-chat'); this.setState({ nameDirt: true }) }} placeholder='Qual é seu nome?' maxLength='70' />
              <div className='text-small text-error ml1 mt1'>Qual seu nome?</div>
            </label>
            <span className='icon mr1'>
              <span className='field-icon'>
                <Icon iconType='far' icon='user' size='sm' />
              </span>
              <span className='text-error'>
                <Icon icon='times' size='sm' />
              </span>
              <span className='text-success'>
                <Icon icon='check' size='sm' />
              </span>
            </span>
          </div>
          <div className={`field-group mb2 ${emailValid === 'is-valid' && 'is-valid'} ${emailValid === 'has-error' && 'has-error'}`}>
            <label>
              <input
                className='mb0'
                type='email'
                value={this.state.email}
                onChange={(event) => this.setState({ email: event.target.value })}
                onBlur={(e) => { handleBlurDatalayer(e, 'email', 'Atendimento-via-chat'); this.setState({ emailDirt: true }) }}
                maxLength='70'
                placeholder='Preencha o seu e-mail, por favor'
              />
              <div className='text-small text-error ml1 mt1'>Preencha o e-mail, por favor</div>
            </label>
            <span className='icon mr1'>
              <span className='field-icon'>
                <Icon icon='at' size='sm' />
              </span>
              <span className='text-error'>
                <Icon icon='times' size='sm' />
              </span>
              <span className='text-success'>
                <Icon icon='check' size='sm' />
              </span>
            </span>
          </div>
          <div className={`field-group mb3 ${phoneValid === 'is-valid' && 'is-valid'} ${phoneValid === 'has-error' && 'has-error'}`}>
            <label>
              <MaskedInput
                mask={TOOLS.cellphoneMask(this.state.phone)}
                guide={false}
                className='mb0'
                type='tel'
                value={this.state.phone}
                onChange={(event) => this.setState({ phone: event.target.value })}
                onBlur={(e) => {
                  handleBlurDatalayer(e, 'phone', 'Atendimento-via-chat')
                  this.setState({ phoneDirt: true })
                }}
                placeholder='Qual é o seu telefone (com DDD)?'
              />
              <div className='text-small text-error ml1 mt1'>Seu telefone com DDD</div>
            </label>
            <span className='icon mr1'>
              <span className='field-icon'>
                <Icon icon='phone' size='sm' />
              </span>
              <span className='text-error'>
                <Icon icon='times' size='sm' />
              </span>
              <span className='text-success'>
                <Icon icon='check' size='sm' />
              </span>
            </span>
          </div>

          {mostrarListaFiliais &&
            <div className={'field-group mb3'}>
              <label>
                <div>
                  <button className={`branchListButton ${this.state.showMenuChat ? 'active' : ''}`} onClick={(event) => this._toggleMenu(event)}>
                    <span>{this.state.branchSelected ? this.state.branchSelected : 'Selecione a loja mais próxima'}</span>
                    <div className='custon-arrow'></div>
                  </button>
                  {this.state.showMenuChat &&
                    <ul className='branchList'>
                      {listaFiliaisAtendimento.map((item, index) => {
                        let siglaEstado = item.siglaEstado.toUpperCase()
                        return (
                          <li key={item.Id} className={this.state.branchSelected === item.Nome ? 'selecionado' : ''}>
                            <button
                              onClick={
                                (event) => {
                                  this._toggleMenu(event)
                                  this._handleChangeBranch(item)
                                }
                              }
                            >
                              <span className='icon hidden'>
                                <Icon icon='check' size='sm' />
                              </span>
                              <span><strong>{item.Nome}</strong></span>
                              <span>{item.Rua}, {item.Numero} - {item.nomeBairro}, {item.nomeCidade} - {siglaEstado}</span>
                            </button>
                          </li>
                        )
                      })}
                    </ul>
                  }
                </div>
                <div className='text-small text-error ml1 mt1'>Preencha a loja mais próxima, por favor</div>
              </label>
              <span className='icon mr1'>
                <span className='field-icon'>
                  <Icon icon='chevron-down' size='sm' />
                </span>
                <span className='text-error'>
                  <Icon icon='times' size='sm' />
                </span>
                <span className='text-success'>
                  <Icon icon='check' size='sm' />
                </span>
              </span>
            </div>
          }

          {this.state.success &&
            <div className='callout success text-center mt4 mb0'>
              <p>{this.state.successMessage || 'Suas informações foram enviadas com sucesso.'}</p>
            </div>
          }
          {this.state.error &&
            <div className='callout alert text-center mt4 mb0'>
              <p>{this.state.errorMessage || 'Não foi possível realizar a sua solicitação.'}</p>
            </div>
          }
          {this.state.warn &&
            <div className='callout warning text-center mt4 mb0'>
              <p>{this.state.warnMessage || 'Algo aconteceu.'}</p>
            </div>
          }

          <div className={'mt3'}>
            <label htmlFor='privacy-field-newsletter'>Prezamos pela privacidade e a coleta dos seus dados pessoais atenderá as diretrizes da legislação aplicável. Para mais informações, acesse nosso{' '}
              <a href='/termos-privacidade' title='Aviso de Privacidade' target='_blank' rel='noreferrer noopener'>Aviso de Privacidade</a>
            </label>
          </div>

          <button className='button info min-width mt4' type='button' disabled={blockSending} onClick={e => this._abrirChat(e)} data-ga-status>Solicitar informações</button>

        </form>
      }
      {this.state.iframeOpened &&
        <div className='hchchat'>
          <iframe loading='lazy' title='hchchat' src={iframe.url} height={iframe.height} width={iframe.width} seamless frameBorder='0' ></iframe>
        </div>
      }
    </Modal>
  }
}
const mapStateToProps = state => {
  return {
    currentUser: state.user.currentUser,
    product: state.products.product,
    region: state.shared.region,
    regions: state.shared.regions,
    highlightModal: state.shared.highlightModal,
    shBranchId: state.shared.shBranchId,
    locations: state.locations.estados,
    branches: state.shared.regionBranches,
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...USER_ACTION,
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalChat)



// WEBPACK FOOTER //
// ./src/components/children/contactForm/ModalChat.js